import { useMemo } from "react";
import { useClinicsForUser } from "@/hooks/useClinics";
import { useCurrentClinicId } from "@/hooks/useAppointments";
import { deriveVisibleClinics, type VisibleClinics } from "@/lib/clinics/visible-clinics";

/**
 * Hook central de "clínicas visíveis". Combina as clínicas que o usuário acessa
 * com a clínica ativa para decidir, em cada tela, entre filtrar por uma clínica
 * (financeiro/operacional) ou consolidar (histórico).
 */
export function useVisibleClinics(): VisibleClinics {
  const { data: clinics = [] } = useClinicsForUser();
  const { data: activeClinicId = null } = useCurrentClinicId();

  return useMemo(
    () => deriveVisibleClinics(clinics, activeClinicId),
    [clinics, activeClinicId],
  );
}
